import type Mithril from 'mithril';
import User from '../models/User';

/**
 * The `fansnum` helper displays a user's fansnum in a <span className="username">
 * tag. If the user doesn't exist, the dan will be displayed as [deleted].
 */
export default function fansnum(user: User | null | undefined | false): Mithril.Vnode {
  const fansnum = (user && user.fansnum()) || 0;

  return <span className="username">{fansnum}</span>;
}